<div class="vehicle-detail">
    <div class="flex-container">
        <h5>{{ '@vehicleDetail' | translate }}: {{ vehicle?.name }}</h5>
        <div class="flex-spacer"></div>
        <img *ngIf="hasMotor" (click)="openFleetCrossDialog()" src="{{assetUrl}}/{{motorSrc}}" width="125px"
            class="image-button border-blue" title="{{'@openMotor' | translate}}">
        <img *ngIf="hasMitchell1" (click)="openMitchell()" src="{{assetUrl}}/{{mitchell1Src}}" width="125px"
            class="image-button border-black" title="{{'@openMitchell1' | translate }}">
    </div>
    <div *ngIf="loading" class="loading-strip">
        <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <div *ngIf="vehicle">
        <app-vehicle-header [vehicle]="vehicle" [vehicleState]="vehicleState"
            [telematicDriver$]="telematicDriver$"></app-vehicle-header>
    </div>
    <div class="flex align-flex-middle icon-with-text red-banner clickable" (click)="outOfServiceBannerClicked()" *ngIf="oosData?.serviceStatusId === ServiceStatus.OutOfService">
        <mat-icon class="make-white">warning</mat-icon>
        <span class="banner-text make-white">
            {{'@vehicleIsOutOfService' | translate }}
        </span>
    </div>
    <mat-tab-group #tabGroup (selectedTabChange)="onTabClick($event)" animationDuration="50ms"
        [selectedIndex]="selectedIndex" *ngIf="vehicle && !loading">
        <mat-tab label="{{ '@summary' | translate }}" *ngIf="canViewVehicleState">
            <div class="content">
                <mat-card appearance="outlined">
                    <mat-card-content *ngIf="vehicleState">
                        <div class="summary-flex">
                        <div class="summary-visual">
                        <div class="flex-col">
                            <div class="flex-25">
                                <div class="flex-container">
                                    <img *ngIf="vehicleState.dashboard.AmberWarningLamp"
                                        title="{{'@checkEngineOn' | translate}}" src="{{assetUrl}}/mil_enabled.png"
                                        class="lamp" />
                                    <img *ngIf="!vehicleState.dashboard.AmberWarningLamp"
                                        title="{{'@checkEngineOff' | translate}}" src="{{assetUrl}}/mil_disabled.png"
                                        class="lamp" /> &nbsp;&nbsp;
                                    <img *ngIf="vehicleState.dashboard.MalfunctionLamp"
                                        title="{{'@malfunctionOn' | translate}}" src="{{assetUrl}}/awl_enabled.png"
                                        class="lamp" />
                                    <img *ngIf="!vehicleState.dashboard.MalfunctionLamp"
                                        title="{{'@malfunctionOff' | translate}}" src="{{assetUrl}}/awl_disabled.png"
                                        class="lamp" />&nbsp;&nbsp;
                                    <img *ngIf="vehicleState.dashboard.ProtectWarningLamp"
                                        title="{{'@protectEngineOn' | translate}}"
                                        src="{{assetUrl}}/protect_enabled.png" class="lamp" />
                                    <img *ngIf="!vehicleState.dashboard.ProtectWarningLamp"
                                        title="{{'@protectEngineOff' | translate}}"
                                        src="{{assetUrl}}/protect_disabled.png"
                                        class="lamp" />&nbsp;&nbsp;
                                    <img *ngIf="vehicleState.dashboard.RedStopLamp"
                                        title="{{'@stopEngineOn' | translate}}" src="{{assetUrl}}/stop_enabled.png"
                                        class="lamp" />
                                    <img *ngIf="!vehicleState.dashboard.RedStopLamp"
                                        title="{{'@stopEngineOff' | translate}}" src="{{assetUrl}}/stop_disabled.png"
                                        class="lamp" /> &nbsp;&nbsp;
                                    <mat-icon class="sensor lamp ignition-on"
                                        *ngIf="vehicleState.engine.activeOrIdle"
                                        title="{{'@ignitionStatusOn' | translate}}">
                                        key
                                    </mat-icon>
                                    <mat-icon class="sensor lamp ignition-off"
                                        *ngIf="!vehicleState.engine.activeOrIdle"
                                        title="{{'@ignitionStatusOff' | translate}}">
                                        key
                                    </mat-icon>
                                    <span class="lamp-actions" *ngIf="useScSensorGrid && vehicleLayout">
                                        <i class="clickable material-icons" (click)="openVehicleMap()"
                                            title="{{ '@toggleMap' | translate }}">location_on</i>
                                        <i class="clickable material-icons" (click)="openVehicleLayoutDialog()"
                                            title="{{ '@vehicleLayoutSummary' | translate }}">settings</i>
                                    </span>
                                </div>

                            </div>
                            <div class="flex-100" *ngIf="(vehicleLayout && vehicleState)">
                                <ng-container *ngIf="useScSensorGrid; else legacyGrid">
                                    <sc-sensor-panel [sensors]="vehicleState.sensors"
                                        [vehicleLayout]="vehicleLayout"
                                        [layoutResolved]="true"
                                        [assetType]="vehicle?.buildConfiguration?.vehicleType || vehicle?.bodyClass"></sc-sensor-panel>
                                </ng-container>
                                <ng-template #legacyGrid>
                                    <app-vehicle-grid [vehicle]="vehicle" [vehicleLayout]="vehicleLayout"
                                        [vehicleState]="vehicleState" [vehicleParts]="vehicleParts"
                                        (callbackFunction)="callbackFunction($event)">
                                    </app-vehicle-grid>
                                </ng-template>
                            </div>
                        </div>
                        </div>
                        <div class="summary-issues" *ngIf="canViewAlert && vehicle?.id && isIssuesFeatureEnabled">
                            <app-issues-widget
                                [assetId]="vehicle.id"
                                [assetName]="vehicle.name"
                                [assetVin]="vehicle.vin"
                                [assetGroups]="vehicle.groups"
                                [canMaintain]="canMaintainAlert">
                            </app-issues-widget>
                        </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
        <mat-tab label="{{ '@telematicDevices' | translate }}">
            <div class="content">
                <mat-card appearance="outlined" *ngIf="vehicle">
                    <mat-card-content>
                        <app-vehicle-devices [vehicle]="vehicle"></app-vehicle-devices>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
        <!-- The sensor panel already lists every sensor on the summary — the tab is redundant with the flag on. -->
        <mat-tab label="{{ '@sensors' | translate }}" *ngIf="canViewVehicleState && !useScSensorGrid">
            <div class="content">
                <mat-card appearance="outlined">
                    <mat-card-content *ngIf="(vehicleLayout && vehicleState)">
                        <div>
                            <div>
                                <app-sensor-value-list [vehicleLayout]="vehicleLayout" [vehicleLayout]="vehicleLayout"
                                    [sensors]="vehicleState.sensors"></app-sensor-value-list>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
        <mat-tab label="{{ '@faults' | translate }}" *ngIf="canViewVehicleState">
            <div class="content">
                <mat-card appearance="outlined">
                    <mat-card-content *ngIf="(vehicleState)">
                        <div>
                            <div>
                                <app-asset-fault [vehicleGroups]="vehicleGroups"></app-asset-fault>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
        <mat-tab label="{{ '@alerts' | translate }}" *ngIf="canViewAlert">
            <div class="content">
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <div>
                            <div>
                                <app-alert [isNested]="true" [vin]="vehicle.vin"></app-alert>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
        <mat-tab label="{{ '@parts' | translate }}" *ngIf="canViewVehicleParts">
            <div class="content">
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <div *ngIf="vehicle">
                            <div class="full-sized">
                                <app-part-table-add altTitle="{{'@assignedParts' | translate}}" [vehicle]="vehicle"
                                    [parts]="vehicleParts" (deleteCallBack)="removeParts($event)"
                                    (editData)="editPart($event)" [tenantId]="tenantId">
                                </app-part-table-add>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
        <mat-tab label="{{ '@dvir' | translate }}">
            <div class="content">
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <div>
                            <div>
                                <app-dvir [tenantId]="tenantId" [vin]="vehicle.vin"
                                    (functionCallback)="callbackFunction($event)">
                                </app-dvir>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
        <mat-tab #maintenanceTab label="{{ '@maintenance' | translate }}" *ngIf="canViewVehicleMaintenance">
            <div class="content">
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <div>
                            <div>
                                <app-vehicle-maintenance [tenantId]="tenantId" [vin]="vehicle.vin"
                                    [refreshMaintenances]="refreshMaintenances"
                                    (functionCallback)="callbackFunction($event)">
                                </app-vehicle-maintenance>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
        <mat-tab #scheduleTab label="{{ '@schedules' | translate }}" *ngIf="canViewVehicleSchedule">
            <div class="content">
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <div>
                            <div>
                                <app-vehicle-schedule [tenantId]="tenantId" [vin]="vehicle.vin"
                                    [refreshSchedules]="refreshSchedules" (functionCallback)="callbackFunction($event)">
                                </app-vehicle-schedule>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
        <mat-tab label="{{ '@configuration' | translate }}">
            <ng-template mat-tab-label>
                <span [matBadge]="configurationErrorCount" [matBadgeHidden]="!configurationError"
                    matBadgeOverlap="false" matBadgeColor="warn">{{ '@configuration' | translate }}</span>
            </ng-template>
            <div class="content">
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <div>
                            <div>
                                <app-vehicle-config #vehicleConfig [tenantId]="tenantId" [vehicle]="vehicle"
                                    [vehicleState]="vehicleState" (functionCallback)="callbackFunction($event)">
                                </app-vehicle-config>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
        <mat-tab label="{{ '@groups' | translate }}" *ngIf="canViewVehicleGroup">
            <div class="content vehicle-groups">
                <mat-card appearance="outlined" class="vehicle-group-card" *ngFor="let group of vehicleGroups">
                    <mat-card-content>
                        <h4 class="vehicle-group-name" (click)="group.expanded = !group.expanded">
                            <i class="fa vehicle-group-toggle"
                                [class.fa-chevron-down]="group.expanded"
                                [class.fa-chevron-right]="!group.expanded"></i>
                            <span class="vehicle-group-label">{{ group.name }}</span>
                            <a *ngIf="group.id" class="vehicle-group-link"
                                (click)="$event.stopPropagation(); openGroup(group.id)"
                                [title]="'@groupDetail' | translate">
                                <i class="fa fa-external-link"></i>
                            </a>
                        </h4>
                        <dl class="vehicle-group-values" *ngIf="group.expanded">
                            <ng-container *ngFor="let item of group.displayValues">
                                <dt>{{ item.key }}</dt>
                                <dd [ngSwitch]="groupValueBool(item.value)">
                                    <i *ngSwitchCase="'true'" class="fa fa-check"></i>
                                    <i *ngSwitchCase="'false'" class="fa fa-times"></i>
                                    <ng-container *ngSwitchDefault>{{ item.value }}</ng-container>
                                </dd>
                            </ng-container>
                        </dl>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>